import { render, staticRenderFns } from "./FreeCreationKeyword.vue?vue&type=template&id=36188cfd&"
import script from "./FreeCreationKeyword.vue?vue&type=script&lang=js&"
export * from "./FreeCreationKeyword.vue?vue&type=script&lang=js&"
import style0 from "./FreeCreationKeyword.vue?vue&type=style&index=0&id=36188cfd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports